import { useNavigate } from 'react-router-dom';
import { handleLogin } from '../services/handleLogin';

export const AuthWall = ({ children }) => {
  const navigate = useNavigate();
  if (localStorage.getItem('accessToken')) {
    return children;
  } else {
    navigate('/login');
  }

  const handleLogin = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_CALLBACK_URL;
    const authorizationUrl = `https://pike13.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}`;

    window.location.href = authorizationUrl;
  };

  return (
    <>
      <img src="./404.png" alt="Error. page cannot be found" width="400" />
      <button
        onClick={handleLogin}
        className="bg-cyan-400 hover:bg-emerald-400 text-white font-semibold px-4 py-2 rounded mt-5 transition-all"
      >
        Log in
      </button>
      <h2 className="mt-5 text-lg dark:text-white font-bold">
        You must be logged in to access this page.
      </h2>
    </>
  );
};